import { Grid, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Skeleton } from "@material-ui/lab";
import React from "react";

const useStyles = makeStyles({
  overlay: {
    width: "99%",
    marginTop: 50,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: "calc(100vh - 180px)",
    "@media (max-width: 600px)": {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 9,
      minHeight: "unset",
      backgroundColor: "var(--color-background-default)",
      alignItems: "center",
      padding: 16,
      boxSizing: "border-box",
    },
  },
  inner: {
    width: "100%",
  },
});

function LoadingLayout() {
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(max-width:960px)");

  const panelHeight = isMobile ? 180 : isTablet ? 260 : 500;

  return (
    <div className={classes.overlay}>
      <div className={classes.inner}>
        <Grid container spacing={isMobile ? 1 : 2}>
          <Grid item xs={12}>
            <Skeleton variant="rect" width="100%" height={56} animation="wave" />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Skeleton variant="rect" width="100%" height={panelHeight} animation="wave" />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Skeleton variant="rect" width="100%" height={panelHeight} animation="wave" />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Skeleton variant="rect" width="100%" height={panelHeight} animation="wave" />
          </Grid>
          <Grid item xs={12}>
            <Skeleton variant="rect" width="100%" height={isMobile ? 120 : panelHeight} animation="wave" />
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default LoadingLayout;
